import { render, staticRenderFns } from "./ValuesInput.vue?vue&type=template&id=045710c7&"
import script from "./ValuesInput.vue?vue&type=script&lang=ts&"
export * from "./ValuesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports